import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Lottie from 'react-lottie';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import { removeOtpData, verifyPhone, openModal } from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {
  formatDatesToDifferentFormats,
  getPackageEndDate,
  getFilteredCountryList,
  getDayBeforeAndAfter,
  isSuitableDates,
  formatPackageDurationLabel,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import {
  createOtpButtonsData,
  saleOTPSteps,
  popupReasonEnum,
  customerTypeEnum,
} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import AbroadPackageTab from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadPackageTab';
import BottomBlock from './BottomBlock';
import BottomBlockChildren from './BottomBlockChildren';
import StepBtn from './StepBtn';
import CreateOtpButtonComponent from '../CellcomAbroadLobbyBlock/OtpVerification/CreateOtpButtonComponent';
import WarningMessageComponent from '../CellcomAbroadLobbyBlock/Shared/Components/Warning/WarningMessageComponent';
import AbroadTooltip from '../CellcomAbroadLobbyBlock/Shared/Components/Tooltip/AbroadTooltip';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import DepartingPlane from '../../../animations/departingPlane.json';
import './AbroadTicketMain.scss';
import { getReportParams, report } from '../../../middleware/report';
import { gaChangeTripDate, gaOnCheckTermCheckBox } from './gaReports';
import * as AbroadPackageModels from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';

const PackageType = AbroadPackageModels.PackageType;
import FamilyBundleSection from './FamilyBundleSection';
import PackageInfo from './PackageInfo/PackageInfo';
import familyBundleIcon from './images/familyBundle.svg';
import AbroadCoupon from './AbroadCoupon';
import {isNullOrEmpty} from '../../../utilities/StringHelpers/StringHelpers';
function AbroadTicketComponent(props) {
  useEffect(() => {
    if (props.data.selectedAbroadPackage?.isFamilyBonus) {
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Cellcom Abroad';
      reportParams.channel =
        props.data.activeLobbyTab && props.data.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate';
      reportParams.actionType = 'Enter ticket with family pkg';
      reportParams.status = 'Ongoing';
      reportParams.messageText = 'Enter ticket with family pkg';
      reportParams.subscriber = props.data.otpDataChildren ? props.data.otpDataChildren.otpPhone : '';
      reportParams.param1 = 'WEBSITE';
      if (props.data.isJETAuthentication) {
        reportParams.param1 = 'JET';
      }
      reportParams.param3 = 'בני משפחות';
      reportParams.param4 = 'מספר מנוי ראשי - ' + props.data.otpData.otpPhone;
      report(reportParams);
    }
  }, []);

  const packageEndDate = getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration, props.data.selectedAbroadPackage?.packageDurationUnit);
  const suitableDates = isSuitableDates(
    props.data.selectedAbroadPackage,
    props.data.dates.datePickerStartJSFormat,
    props.data.dates.datePickerEndJSFormat,
  );
  const unsupportedCountries = props.data.selectedAbroadPackage?.countrySupportedList?.length
    ? getFilteredCountryList(props.data.selectedCountries, props.data.selectedAbroadPackage.countrySupportedList)
    : null;
  const [checkBoxChecked, setCheckBoxIsChecked] = useState(false);
  const [checkBoxCollaborationChecked, setCheckBoxCollaborationIsChecked] = useState(false);
  const selectedCountries = getIncludedCountries();
  const [showErrorMessage, setShowMessage] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState('כדי להמשיך יש לאשר את תנאי החבילה');
  const [showPaymentErrorMessage, setPaymentMessage] = useState(false);
  const [isStopped, setIsStopped] = useState(true);
  const showCollaborationCheckBox = showCheckBoxCollaboration();
  const isOtpStep = props.data.otpData.saleOTPStep == saleOTPSteps.OTP || props.data.otpDataChildren.saleOTPStep == saleOTPSteps.OTP;
  const isRegistered = props.data.otpData.saleOTPStep === saleOTPSteps.AFTER_INPUT || props.data.otpDataChildren.saleOTPStep === saleOTPSteps.AFTER_INPUT; 
  const isBusinessIndividualLobby = props.data.epiStyleInitializationData.businessIndividualLobby;
  const showCoupon = !isBusinessIndividualLobby && !isNullOrEmpty(props.data.selectedAbroadPackage?.socCatalogId);
  const abroadCouponIsValid = showCoupon && props.data.coupon?.isValid;
  const activateAnimation = () => {
    setIsStopped(false);
  };

  //extend for more package types with their indicators;
  const [packageType, setPackageType] = useState(null);

  // Listen for clear error event from family bundle member selection
  useEffect(() => {
    const handleClearError = () => {
      setShowMessage(false);
    };
    window.addEventListener('clearFamilyBundleError', handleClearError);
    setPackageType(determinePackageType());
    return () => {
      window.removeEventListener('clearFamilyBundleError', handleClearError);
    };
  }, []);

  function determinePackageType() {
    if (props.data.selectedAbroadPackage?.isFamilyBundle) {
      return PackageType.FAMILY_BUNDLE;
    }
    return null;
  }

  function getIncludedCountries() {
    let countriesToShow =
      props.data.selectedCountriesUsedInSearch?.length > 0 ? props.data.selectedCountriesUsedInSearch : props.data.selectedCountries;
    let filteredCountriesToShow = [];
    if (unsupportedCountries?.length > 0) {
      filteredCountriesToShow = getFilteredCountryList(countriesToShow, unsupportedCountries);
      return filteredCountriesToShow;
    }
    return countriesToShow;
  }

  async function OtpVerifyPhone(isVoice) {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    await props.verifyPhone({
      phoneNumber: props.data.otpPhoneForm.phone,
      asVoice: isVoice,
      captchaToken: captchaToken
    });
  }

  function changeTripDate() {
    gaChangeTripDate(
      props.businessOrPrivate,
      props.data.startedFromPackage,
      props.data.otpData.validatedCostumerData?.isSeparatedSale,
      props.data.epiStyleInitializationData.businessIndividualLobby,
    );
    props.openModal(popupReasonEnum.CHANGE_PACKAGE_START_DAY);
  }

  //function to connect backend and check if Collaboration is active already
  function showCheckBoxCollaboration() {
    //connection to interface 1847
    //check if consumer has Collaboration on true or false
    return props.NeedToSignCollaborationApproval;
  }

  function onCheck() {
    gaOnCheckTermCheckBox(
      props.businessOrPrivate,
      props.data.startedFromPackage,
      props.data.epiStyleInitializationData.businessIndividualLobby,
    );

    setShowMessage(false);
    setCheckBoxIsChecked(!checkBoxChecked);
  }

  function onUncheck() {
    setCheckBoxIsChecked(!checkBoxChecked);
  }

  function onCheckCollaboration() {
    setCheckBoxCollaborationIsChecked(!checkBoxCollaborationChecked);
    props.onChangeCollaboration(!checkBoxCollaborationChecked);
  }

  function onUncheckCollaboration() {
    setCheckBoxCollaborationIsChecked(!checkBoxCollaborationChecked);
    props.onChangeCollaboration(!checkBoxCollaborationChecked);
  }

  const getTooltipMessageText = () => {
    let dayBeforeStartDay = getDayBeforeAndAfter(props.data.dates.datePickerStartJSFormat, true);
    let startPackage = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedUI.slice(0, 5);

    let dayAfterEndDay = getDayBeforeAndAfter(
      getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration).formattedISOS,
      false,
    );
    let endPackage = formatDatesToDifferentFormats(
      getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration).formattedISOS,
    ).formattedUI.slice(0, 5);

    return `החבילה תהיה בתוקף מהלילה שבין ${dayBeforeStartDay} ל-${startPackage}, ועד הלילה שבין ${endPackage} ל-${dayAfterEndDay}, בשעה 00:00`;
  };

  function handleSubmit(event) {
    event.preventDefault();
  }

  const gaAndOpenTooltip = () => {
    switch (props.businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE.category,
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_TOOLTIP_IS_OPENED_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        break;
      default:
        break;
    }
  };

  const warningGaReport = () => {
    let eventParam = '';
    if (!suitableDates) {
      eventParam += ' .חבילה מסתיימת לפני התאריך שבחרת';
    }
    if (unsupportedCountries?.length > 0) {
      eventParam += ` .החבילה לא כוללת את מדינה/מדינות`;
    }

    switch (props.businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE_FROM_PACKAGE.eventType,
            eventParam,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE.category,
            gaParams.ABROAD_TICKET_WARNING_MESSAGE_IS_SHOWN_PRIVATE.eventType,
            eventParam,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        break;
      default:
        break;
    }
  };

  const getSelectedAccountNumber = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      return <h2 className='TicketSubscriberHeading'>מנוי {props.data.businessIndividualData.selectedAccountNumber}</h2>;
    } else if ( !props.data.selectedAbroadPackage?.isFamilyBonus && (props.data.otpDataChildren.otpPhone || props.data.otpData.otpPhone)) {
      let number = props.data.otpDataChildren.otpPhone ? props.data.otpDataChildren.otpPhone : props.data.otpData.otpPhone;
      return <h2 className='TicketSubscriberHeading'>מנוי {number}</h2>;
    }
    return null;
  };

  return (
    <form
      noValidate
      id='cellcom-abroad-otp'
      onSubmit={handleSubmit}
      className={`${isMobile ? 'isMobile mr-auto ml-auto' : 'w-100'} ticket-form`}>
      {props.data.otpDataChildren.saleOTPStep == saleOTPSteps.AFTER_INPUT || props.data.otpData.saleOTPStep == saleOTPSteps.AFTER_INPUT ? (
        <>{getSelectedAccountNumber()}</>
      ) : null}
      <div
        className='abroad-ticket-main mr-auto ml-auto'
        style={
          !(
            props.data.otpDataChildren.saleOTPStep == saleOTPSteps.AFTER_INPUT || props.data.otpData.saleOTPStep == saleOTPSteps.AFTER_INPUT
          )
            ? { marginTop: '18px' }
            : {}
        }>
        <div className='white-top-box-container'>
          <div className='top-content-container'>
            <div className='white-top-pic'>
              {/* <Plane /> */}
              <Lottie options={{ animationData: DepartingPlane, loop: false, autoplay: false }} isStopped={isStopped} />
            </div>
            <AbroadPackageTab
              packageData={props.data.selectedAbroadPackage}
              supportedApps={props.data.getEpiGeneralData.supportedApps}
              context={props.context}
              isInTicket={true}
              businessOrPrivate={props.businessOrPrivate}
              comingFromPackageManager={props.data.comingFromPackageManager}
              businessSocPackageFolderId={props.data.epiStyleInitializationData.businessSocPackageFolderId}
              privateSocPackageFolderId={props.data.epiStyleInitializationData.privateSocPackageFolderId}
            />
          </div>
          {packageType === PackageType.FAMILY_BUNDLE && (
            <PackageInfo iconSrc={familyBundleIcon}>
             <span>מהי חבילת חו״ל משפחתית ומה היא <br /> כוללת?{' '}</span>
              <span className="package-info-link" onClick={() => props.openModal(popupReasonEnum.DISPLAY_INFO_FAMILY_BUNDLE)}>
               לכל הפרטים החשובים
              </span>
            </PackageInfo>
          )}
        </div>

        {/* <UpperBlock /> */}
        <div className='grey-mid-box-container'>
          <div className='where-flight-to-box'>
            {!props.data.comingFromPackageManager ? (
              <>
                <div className='where-flight-to-header'>יעדים שכלולים בחבילה</div>
                <div className='where-flight-to-text'>
                  {selectedCountries.map((country, index) => {
                    return (
                      <span className='ml-1' key={index}>
                        <bdi>{country.countryHebName}</bdi>
                        {index < selectedCountries.length - 1 ? ',' : ''}
                      </span>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                <div
                  className='where-flight-to-box--stateInclude'
                  onClick={() => props.openModal(popupReasonEnum.STATE_SUPPORTED)}>{`לצפייה במדינות שנתמכות בחבילה >`}</div>
              </>
            )}
            <hr />
            <div className='where-flight-to-header'>
              תוקף החבילה שבחרתם:{' '}
              {props.data.selectedAbroadPackage?.packageDuration > 0 &&
                formatPackageDurationLabel(
                  props.data.selectedAbroadPackage?.packageDuration,
                  props.data.selectedAbroadPackage?.packageDurationUnit,
                )}
            </div>
            {props.data.selectedAbroadPackage?.packageDuration > 0 ? (
              <>
                <div className='where-flight-to-text'>
                  החבילה תתחיל ב - {props.data.dates.selectedStartDate}
                  <span className='pink-text-click' onClick={() => changeTripDate()}>
                    שינוי
                  </span>
                </div>
                <div className='where-flight-to-text'>
                  <span className='align-middle'>
                    {' '}
                    {props.data.selectedAbroadPackage?.packageDuration > 0 ? ` ותסתיים ב ${packageEndDate.formattedUI}` : `text`}
                  </span>
                  <span className='mr-1' onClick={() => gaAndOpenTooltip()}>
                    <AbroadTooltip tooltipText={getTooltipMessageText()} tooltipId={'abroad-ticket-tooltip'} placement={'left'} />
                  </span>
                </div>
              </>
            ) : (
              <div className='where-flight-to-text'>
                {' '}
                החבילה תקפה לאורך כל הנסיעה מהנחיתה <br /> ביעד ועד החזרה לישראל{' '}
              </div>
            )}

        
            {(unsupportedCountries?.length > 0 || !suitableDates) && (
              <div className='warning-box'>
                <WarningMessageComponent
                  unsupportedCountries={unsupportedCountries?.length > 0 ? unsupportedCountries : null}
                  isSuitableDates={suitableDates}
                  isBusiness={props.data.otpData.validatedCostumerData?.accountType != customerTypeEnum.PRIVATE ? true : false}
                  gaReport={warningGaReport}
                />
              </div>
            )}
          </div>
        </div>
        {!props.data.businessIndividualData.allowIndependentFuturePurchases && (
          <>
            <div className='line'>
              <div className='inner-line'></div>
            </div>
            <div className='charge-box-details-container'>
              <div className='charge-price-line'>
                <div className='text'>חיוב חד פעמי</div>

                <div className='price-text-container'> 
                  <div className={`price-text ${abroadCouponIsValid ? 'line-through' : ''}`}>₪{props.data.selectedAbroadPackage?.price ? props.data.selectedAbroadPackage?.price : 0}</div>
                  {abroadCouponIsValid && <div className='price-text new-price'>₪{props.data.coupon?.voucherAmount}</div>}
                </div>
              </div>
              <div className='description-invoice-text'>
                {props.data.selectedAbroadPackage?.isBankOrByUse != 'Bank' && (
                  <span className='d-block'>חיובים נוספים יתבצעו לפי השימוש בפועל </span>
                )}

                <span className='d-block'> החיוב יבוצע בחשבונית החודשית</span>
              </div>
            </div>
          </>
        )}
       
        {showCoupon && <AbroadCoupon/>}


        <div className='dashed-border-box'>
          <div className='right-circle'></div>
          <div className='left-circle'></div>
        </div>

        <div className='grey-bottom-box-container'>
          {props.data.otpData?.isFamilyProcess ? (
            <BottomBlockChildren
              onCheck={onCheck}
              onUncheck={onUncheck}
              checkBoxChecked={checkBoxChecked}
              showErrorMessage={showErrorMessage}
              businessOrPrivate={props.businessOrPrivate}
              paymentErrorMessage={showPaymentErrorMessage}
              submitValidateCustomerType={props.submitValidateCustomerType}
              checkBoxText={props.checkBoxText}
              NeedToSignCollaborationApproval={props.NeedToSignCollaborationApproval}
              onCheckCollaboration={onCheckCollaboration}
              onUncheckCollaboration={onUncheckCollaboration}
              checkBoxCollaborationChecked={checkBoxCollaborationChecked}
              showCollaborationCheckBox={showCollaborationCheckBox}
            />
          ) : (
            <BottomBlock
              onCheck={onCheck}
              onUncheck={onUncheck}
              context={props.context}
              checkBoxChecked={checkBoxChecked}
              showErrorMessage={showErrorMessage}
              setShowMessage={setShowMessage}
              setErrorMessageText={setErrorMessageText}
              businessOrPrivate={props.businessOrPrivate}
              paymentErrorMessage={showPaymentErrorMessage}
              submitValidateCustomerType={props.submitValidateCustomerType}
              checkBoxText={props.checkBoxText}
              newTermsUrl={props.newTermsUrl}
              NeedToSignCollaborationApproval={props.NeedToSignCollaborationApproval}
              onCheckCollaboration={onCheckCollaboration}
              onUncheckCollaboration={onUncheckCollaboration}
              checkBoxCollaborationChecked={checkBoxCollaborationChecked}
              showCollaborationCheckBox={showCollaborationCheckBox}
            />
          )}
        </div>
      </div>

      {(props.data.otpData.saleOTPStep == saleOTPSteps.OTP || props.data.otpDataChildren.saleOTPStep == saleOTPSteps.OTP) && (
        <div className='otp-section d-flex m-auto'>
          {createOtpButtonsData.map((button, index) => {
            return (
              <CreateOtpButtonComponent
                key={index}
                alt={button.alt}
                description={button.description}
                icon={button.icon}
                action={button.id == 'sms' ? () => OtpVerifyPhone(false) : () => OtpVerifyPhone(true)}
              />
            );
          })}
        </div>
      )}

      <div className='step-button-container justify-content-center'>
        {showErrorMessage && (
          <div className='bottom-error-message'>{errorMessageText}</div>
        )}
        <StepBtn
          checkBoxChecked={checkBoxChecked}
          checkBoxCollaborationChecked={checkBoxCollaborationChecked}
          setShowMessage={setShowMessage}
          setErrorMessageText={setErrorMessageText}
          setPaymentErrorMessage={setPaymentMessage}
          showErrorMessage={showErrorMessage}
          businessOrPrivate={props.businessOrPrivate}
          activateAnimation={() => activateAnimation()}
          submitValidateCustomerType={props.submitValidateCustomerType}
        />
      </div>
    </form>
  );
}

const mapStateToProps = (state) => ({
  data: state.cellcomAbroad
});

const mapDispatchToProps = {
  removeOtpData,
  openModal,
  verifyPhone
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadTicketComponent);
